import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';


import { fadeInOut } from '../../services/animations';
import { BootstrapTabDirective } from '../../directives/bootstrap-tab.directive';
import { AccountService } from '../../services/account.service';
import { Permission } from '../../models/permission.model';
import { AlertService, MessageSeverity } from '../../services/alert.service';

import { UserInfoComponent } from './../controls/user-info.component';
@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    animations: [fadeInOut],
    standalone: false
})
export class SettingsComponent implements OnInit, OnDestroy {

  isProfileActivated = true;
  isPreferencesActivated = false;
  isUsersActivated = false;
  isRolesActivated = false;
  isEmailsActivated = false;            // <--- new

  fragmentSubscription: any;

  readonly profileTab = 'profile';
  readonly preferencesTab = 'preferences';
  readonly usersTab = 'users';
  readonly rolesTab = 'roles';
  readonly emailsTab = 'emails';        // <--- new


  @ViewChild('tab', { static: true })
  tab: BootstrapTabDirective;

  @ViewChild(UserInfoComponent)
  userInfoComponent!: UserInfoComponent;

  constructor(private router: Router, private route: ActivatedRoute, private accountService: AccountService, private alertService: AlertService,) {
  }


  ngOnInit() {
    this.fragmentSubscription = this.route.fragment.subscribe(anchor => this.showContent(anchor));
    this.route.queryParams.subscribe(params => {

      if (params['forcePasswordChange']) {

        setTimeout(() => {

          if (this.userInfoComponent) {
            this.alertService.showStickyMessage('Change Password', 'First Time passoword should change ', MessageSeverity.error);
            this.userInfoComponent.edit();
            this.userInfoComponent.changePassword();
            
          }

        }, 500);

      }

    });
  }


  ngOnDestroy() {
    this.fragmentSubscription.unsubscribe();
  }

  showContent(anchor: string) {
    if (anchor) {
      anchor = anchor.toLowerCase();
    }

    if ((this.isFragmentEquals(anchor, this.usersTab) && !this.canViewUsers) ||
      (this.isFragmentEquals(anchor, this.rolesTab) && !this.canViewRoles)) {
      return;
    }

    this.tab.show(`#${anchor || this.profileTab}Tab`);
  }


  isFragmentEquals(fragment1: string, fragment2: string) {

    if (fragment1 == null) {
      fragment1 = '';
    }

    if (fragment2 == null) {
      fragment2 = '';
    }

    return fragment1.toLowerCase() === fragment2.toLowerCase();
  }


  onShowTab(event) {
    const activeTab = event.target.hash.split('#', 2).pop();

    this.isProfileActivated = activeTab === this.profileTab;
    this.isPreferencesActivated = activeTab === this.preferencesTab;
    this.isUsersActivated = activeTab === this.usersTab;
    this.isRolesActivated = activeTab === this.rolesTab;
    this.isEmailsActivated = activeTab === this.emailsTab; // <--- new

    // keep fragment in url so deep-link works
    this.router.navigate([], { fragment: activeTab });
  }


  get canViewUsers() {
    return this.accountService.userHasPermission(Permission.viewUsersPermission);
  }

  get canViewRoles() {
    return this.accountService.userHasPermission(Permission.viewRolesPermission);
  }
}
